import { EmptyState, Button, Icon, icons, Stack } from '@agentisai/design-system';
import { useAuth } from '../auth/AuthProvider';

/**
 * NoTenantPage — shown by <RequireTenant> when an authenticated user has no
 * tenant affiliation. UX gating only; the server is the real access
 * boundary (R13/SR5). The single action is Logout (NOT a home link), per
 * the S-E3 acceptance criteria.
 */
export function NoTenantPage() {
  const { logout } = useAuth();
  return (
    <Stack as="main" align="center" justify="center" style={{ minHeight: '70vh', padding: 48 }}>
      <EmptyState
        icon={<Icon as={icons.ShieldCheck} size="lg" />}
        title="No workspace access yet"
        description="Your account isn't affiliated with an organisation. Ask your administrator for an invite, then sign in again."
        action={
          <Button variant="primary" onClick={logout}>
            Log out
          </Button>
        }
      />
    </Stack>
  );
}
NoTenantPage.displayName = 'NoTenantPage';
